var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-back"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back",
    clipPath: "url(#clip-back)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9247",
    "data-name": "Group 9247",
    transform: "translate(-433 -345)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left-arrow_5_",
    "data-name": "left-arrow(5)",
    transform: "translate(438.821 300.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9248",
    "data-name": "Group 9248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18488",
    "data-name": "Path 18488",
    d: "M5.678,64.677a.3.3,0,0,1-.212-.087L.087,59.212a.3.3,0,0,1,0-.423l5.378-5.379a.3.3,0,0,1,.423.422L.722,59l5.167,5.167a.3.3,0,0,1-.211.51Z",
    fill: "#2f394e",
    stroke: "#2f394e",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18489",
    "data-name": "Path 18489",
    d: "M17.911,245.783H.389a.308.308,0,1,1,0-.6H17.911a.308.308,0,1,1,0,.6Z",
    transform: "translate(-0.006 -186.484)",
    fill: "#2f394e",
    stroke: "#2f394e",
    strokeWidth: 0.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.fbb0b924961e904f3838785499d11bdb.svg";
export { ForwardRef as ReactComponent };